export const SIGNIFYD_LIBRARY_URL =
  'https://cdn-scripts.signifyd.com/api/script-tag.js'
